import React, { useEffect, useRef } from "react";
import "./Clients.css";

import logo_acos_alianca from "../imgs/logo_acos_alianca.png";
import logo_belotur from "../imgs/logo_belotur.png";
import logo_bmg from "../imgs/logo_bmg.webp";
import logo_cohab from "../imgs/logo_cohab.webp";
import logo_cra from "../imgs/logo_cra.png";
import logo_fiocruz from "../imgs/logo_fiocruz.png";
import logo_magnesita from "../imgs/logo_magnesita.png";
import logo_igarape from "../imgs/logo_igarape.png";
import logo_odilon from "../imgs/logo_odilon.png";
import logo_sms from "../imgs/logo_sms.png";
import logo_spda from "../imgs/logo_spda.png";
import logo_unimed from "../imgs/logo_unimed.webp";
import logo_fundep from "../imgs/logo_fundep.png";
import logo_telemont from "../imgs/logo_telemont.png";
import logo_vilma from "../imgs/logo_vilma.png";
import logo_espmg from "../imgs/logo_espmg.png";
import logo_feeb from "../imgs/logo_feeb.webp";

import BackToTop from "./BackToTop";
import ButtonZap from "../components/ButtonZap";
import Title from "../styled-components/Title";

import {
  acosAliancaSite,
  beloturSite,
  bmgSite,
  cohabSite,
  craSite,
  fiocruzSite,
  odilonSite,
  paulwurthSite,
  rhMagnesiteSite,
  igarapeSite,
  spdaSite,
  unimedSite,
  fundepSite,
  telemontSite,
  vilmaSite,
  espmgSite,
  feebSite
} from "../imports/Links";

function Clients() {
  const track1Ref = useRef(null);
  const track2Ref = useRef(null);

  // lista fixa
  const logos = [
    { img: logo_fiocruz, alt: "Fiocruz", link: fiocruzSite },
    { img: logo_magnesita, alt: "RHI Magnesita", link: rhMagnesiteSite },
    { img: logo_igarape, alt: "Prefeitura de Igarapé", link: igarapeSite },
    { img: logo_acos_alianca, alt: "Aços Aliança", link: acosAliancaSite },
    { img: logo_belotur, alt: "Belotur", link: beloturSite },
    { img: logo_bmg, alt: "Banco BMG", link: bmgSite },
    { img: logo_cohab, alt: "COHAB Minas", link: cohabSite },
    { img: logo_cra, alt: "CRA-MG", link: craSite },
    { img: logo_fundep, alt: "FUNDEP", link: fundepSite },
    { img: logo_telemont, alt: "Telemont", link: telemontSite },
    { img: logo_vilma, alt: "Vilma Alimentos", link: vilmaSite },
    { img: logo_espmg, alt: "ESPMG", link: espmgSite },
    { img: logo_spda, alt: "SPDA", link: spdaSite },
    { img: logo_unimed, alt: "Unimed", link: unimedSite },
    { img: logo_odilon, alt: "Hospital Odilon Behrens", link: odilonSite },
    { img: logo_sms, alt: "Paul Wurth", link: paulwurthSite },
    { img: logo_feeb, alt: "FEEB", link: feebSite },
  ];

  // divide metade pra cada linha (sem randomizar)
  const mid = Math.ceil(logos.length / 2);
  const line1 = [...logos.slice(0, mid), ...logos.slice(0, mid)];
  const line2 = [...logos.slice(mid), ...logos.slice(mid)];

  // corrige velocidade automática
  useEffect(() => {
    const el1 = track1Ref.current;
    const el2 = track2Ref.current;
    if (!el1 || !el2) return;

    const setSpeed = () => {
      const w1 = el1.scrollWidth;
      const w2 = el2.scrollWidth;
      el1.style.animationDuration = `${w1 / 80}s`;
      el2.style.animationDuration = `${w2 / 85}s`;
    };

    setSpeed();
    window.addEventListener("resize", setSpeed);
    return () => window.removeEventListener("resize", setSpeed);
  }, []);

  return (
    <div className="Clients">
      <main>
        <div id="main-clients">
          <Title>Alguns dos nossos clientes</Title>

          <div className="logos-carousel">
            {/* Linha 1 */}
            <div ref={track1Ref} className="logos-track track1">
              {line1.map((logo, i) => (
                <div className="logo-item" key={`l1-${i}`}>
                  <a href={logo.link} target="_blank" rel="noreferrer noopener">
                    <img src={logo.img} alt={logo.alt} />
                  </a>
                </div>
              ))}
            </div>

            {/* Linha 2 */}
            <div ref={track2Ref} className="logos-track track2">
              {line2.map((logo, i) => (
                <div className="logo-item" key={`l2-${i}`}>
                  <a href={logo.link} target="_blank" rel="noreferrer noopener">
                    <img src={logo.img} alt={logo.alt} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <BackToTop />
      <ButtonZap />
    </div>
  );
}

export default Clients;
